var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProvidersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.783,
    height: 22.09,
    viewBox: "0 0 23.783 22.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1189",
    "data-name": "Rectangle 1189",
    width: 4.788,
    height: 5.65,
    rx: 2.394,
    transform: "translate(9.093 13.699)",
    fill: "#fff",
    stroke: "gray",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_131",
    "data-name": "Ellipse 131",
    cx: 1.995,
    cy: 1.995,
    r: 1.995,
    transform: "translate(9.491 10.016)",
    fill: "#fff",
    stroke: "gray",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M23.308,8.669V19.216A3.541,3.541,0,0,1,19.9,22.872H3.929a3.536,3.536,0,0,1-3.4-3.646V8.669a1.45,1.45,0,0,1,1.4-1.5H4.963a1.45,1.45,0,0,1,1.4,1.5v8.562a1.451,1.451,0,0,0,1.4,1.5h8.829a1.45,1.45,0,0,0,1.4-1.5V8.669a1.45,1.45,0,0,1,1.4-1.5H21.9a1.45,1.45,0,0,1,1.4,1.493Z",
    transform: "translate(-0.525 -1.782)",
    fill: "#fff",
    stroke: "gray",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1190",
    "data-name": "Rectangle 1190",
    width: 4.527,
    height: 8.084,
    rx: 2,
    transform: "translate(0.001 0)",
    fill: "#fff",
    stroke: "gray",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1191",
    "data-name": "Rectangle 1191",
    width: 4.527,
    height: 8.084,
    rx: 2,
    transform: "translate(4.527 0)",
    fill: "#fff",
    stroke: "gray",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1192",
    "data-name": "Rectangle 1192",
    width: 4.527,
    height: 8.084,
    rx: 2,
    transform: "translate(9.054 0)",
    fill: "#fff",
    stroke: "gray",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1193",
    "data-name": "Rectangle 1193",
    width: 4.527,
    height: 8.084,
    rx: 2,
    transform: "translate(13.729 0)",
    fill: "#fff",
    stroke: "gray",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1194",
    "data-name": "Rectangle 1194",
    width: 4.527,
    height: 8.084,
    rx: 2,
    transform: "translate(18.256 0)",
    fill: "#fff",
    stroke: "gray",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProvidersIcon);
export default __webpack_public_path__ + "static/media/providers_icon.0c4732f8a375914b04470940cfbfe66d.svg";
export { ForwardRef as ReactComponent };